module.exports = __webpack_public_path__ + "assets/img/8_1645_big.a3648de6.jpg";